/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateTaskProgressCommand } from '../../models/update-task-progress-command';
import { UpdateTaskProgressCommandResult } from '../../models/update-task-progress-command-result';

export interface ApiTaskProgressUpdateTaskProgressPost$Plain$Params {
      body?: UpdateTaskProgressCommand
}

export function apiTaskProgressUpdateTaskProgressPost$Plain(http: HttpClient, rootUrl: string, params?: ApiTaskProgressUpdateTaskProgressPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateTaskProgressCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiTaskProgressUpdateTaskProgressPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateTaskProgressCommandResult>;
    })
  );
}

apiTaskProgressUpdateTaskProgressPost$Plain.PATH = '/api/TaskProgress/UpdateTaskProgress';
